import React, { useState } from 'react';
import Popup from 'reactjs-popup';

const TransferModal = ({ open, onClose, onSubmit, tickets, submitting }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [note, setNote] = useState('');
  const [selected, setSelected] = useState([]);

  const toggle = (id) => setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  const canSubmit = firstName.trim() && lastName.trim() && email.trim() && selected.length > 0 && !submitting;

  const submit = (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    onSubmit({ firstName, lastName, email, note, ticketIds: selected });
  };

  return (
    <Popup open={open} onClose={onClose} modal closeOnDocumentClick className="popup-modal">
      <form className="op-modal" onSubmit={submit}>
        <h2 className="op-section-title">Transfer tickets</h2>

        {tickets.length === 0 ? (
          <p className="op-muted">No tickets on this order are eligible to transfer.</p>
        ) : (
          <>
            <span className="op-label">Tickets to transfer</span>
            <div className="op-transfer-tickets">
              {tickets.map((t) => (
                <label key={`${t.kind}-${t.id}`} className="op-checkbox">
                  <input type="checkbox" checked={selected.includes(t.id)} onChange={() => toggle(t.id)} />
                  <span>{t.productName}{t.attendeeName ? ` — ${t.attendeeName}` : ''}</span>
                </label>
              ))}
            </div>

            <label className="op-label" htmlFor="op-tx-first">Recipient first name</label>
            <input id="op-tx-first" className="op-input" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />

            <label className="op-label" htmlFor="op-tx-last">Recipient last name</label>
            <input id="op-tx-last" className="op-input" value={lastName} onChange={(e) => setLastName(e.target.value)} required />

            <label className="op-label" htmlFor="op-tx-email">Recipient email</label>
            <input id="op-tx-email" className="op-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />

            <label className="op-label" htmlFor="op-tx-note">Note (optional)</label>
            <textarea id="op-tx-note" className="op-input op-textarea" rows={3} value={note} onChange={(e) => setNote(e.target.value)} />
          </>
        )}

        <div className="op-modal-actions">
          <button type="button" className="op-btn" onClick={onClose} disabled={submitting}>Cancel</button>
          <button type="submit" className="op-btn op-btn-primary" disabled={!canSubmit}>{submitting ? 'Transferring…' : 'Transfer tickets'}</button>
        </div>
      </form>
    </Popup>
  );
};

export default TransferModal;
